<script>
  import Booking from "./Booking.svelte";
  import DetailView from "./DetailView.svelte";

  export let item;
  export let anmeldestop = false;
  export let eventlistData = {};
  // export let anmeldestopO2o = false;
</script>

<DetailView {item} headline="Gruppengespräch" attachmentInfo="Laden Sie sich den Inhalt des Gruppengespräches als PDF herunter:" companyNameBeforePerson>
  <p slot="lead">
    <strong>Fragen:</strong>
    {item.text1fragenHtml}<br />
    <strong>Antworten:</strong>
    {item.text1antwortenHtml}
  </p>
  <Booking slot="whitebox" {item} {anmeldestop} {eventlistData} on:booking on:showVeranstaltung />
</DetailView>
